export type Type = {
  street: string
  streetLine2: string
  city: string
  state: string
  postalCode: string
}

const getStreetString = (street, streetLine2) =>
  streetLine2 ? `${street} ${streetLine2}` : street

export const getAddressString = (
  { street, streetLine2, city, state, postalCode } = {
    street: '',
    streetLine2: '',
    city: '',
    state: '',
    postalCode: '',
  }
) =>
  `${getStreetString(
    typeof street === 'undefined' ? '' : street,
    typeof streetLine2 === 'undefined' ? '' : streetLine2
  )}, ${city}, ${state}, ${postalCode}`
